import { render, staticRenderFns } from "./cardTemplateVip31.vue?vue&type=template&id=3001ddbe&scoped=true&"
import script from "./cardTemplateVip31.vue?vue&type=script&lang=js&"
export * from "./cardTemplateVip31.vue?vue&type=script&lang=js&"
import style0 from "./cardTemplateVip31.vue?vue&type=style&index=0&id=3001ddbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3001ddbe",
  null
  
)

export default component.exports